//#region Icons
import OpenBookIcon from "icons/OpenBookIcon";
import ActivityIcon from "icons/ActivityIcon";
import HomeIcon from "icons/HomeIcon";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import { PERMISSIONS_VIEWS } from "config/userPermissions";
import { RESOURCE_MODULE_TITLES, onlyResourceModules } from "views/Recursos/utils/constants";
//#endregion

const { RECURSOS } = PERMISSIONS_VIEWS;
export const TOOLTIP_PROPS = {
    maxSize: {
        x: "20%", y: "-60%",
        width: "160px",
        height: "80px",
        after: {
            x: "-430%", y: "-220%",
            angle: "135deg"
        }
    },
    minSize: {
        x: "-75%",
        y: "-180%",
        width: "130px",
        after: {
            x: "170%", y: "5%",
            angle: "45deg"
        }
    }
};

export const INFORMATION_LINKS = [
    {
        id: RECURSOS.BIBLIOTECA,
        title: RESOURCE_MODULE_TITLES.LIBRARY,
        icon: <OpenBookIcon/>,
        to: ABSOLUTE_PATHS.RESOURCES_LIBRARY,
        tooltip: {
            message: "Registra Tablets, Computadoras y/o Salas Grupales",
            props: {
                ...TOOLTIP_PROPS,
                maxSize: {
                    ...TOOLTIP_PROPS.maxSize,
                    x: "30%",
                    after: {
                        ...TOOLTIP_PROPS.maxSize.after,
                        x: "-88px",
                        y: "-45px"
                    }
                },
                minSize: {
                    ...TOOLTIP_PROPS.minSize,
                    x: "-50%",
                    y: "-170%",
                    width: "160px",
                    after: {
                        ...TOOLTIP_PROPS.minSize.after,
                        x: "0px",
                        y: "4px"
                    }
                }
            }
        }
    }, 
    {
        id: RECURSOS.ESPACIOS_UNIVERSITARIOS,
        title: RESOURCE_MODULE_TITLES.UNIVERSITY_SPACES,
        icon: <ActivityIcon/>,
        to: ABSOLUTE_PATHS.RESOURCES_UNIVERSITY_SPACES,
        tooltip: {
            props: {
                maxSize: {
                    ...TOOLTIP_PROPS.maxSize,
                    x: "30%", y: "-80%",
                    height: "60px",
                    after: {
                        ...TOOLTIP_PROPS.maxSize.after,
                        x: "-88px",
                        y: "-30px"
                    }
                },
                minSize: {
                    ...TOOLTIP_PROPS.minSize,
                    y: "-170%",
                    after: {
                        ...TOOLTIP_PROPS.minSize.after,
                        y: "20%"
                    }
                }
            },
            message: "Gestión de espacios universitarios"
        }
    }, 
    {
        id: null,
        title: "Otros espacios",
        icon: <HomeIcon/>,
        to: ABSOLUTE_PATHS.RESOURCES,
        tooltip: {
            message: "Gestión de otros espacios"
        }
    }
].filter(onlyResourceModules);